getAnnotationLegantoUtil = (function(){
    var instance;
    return {
        get : function(){
            if(!instance){
                instance = new AnnotationLegantoUtil();
            }
            return instance;
        }
    }
})();

function AnnotationLegantoUtil(){
    var s = {
        interactionPoint: null
    };

    var annsByEntityType = {};

    menus = [];

    var annToTrash;
    function trash(){
        if(annToTrash){
            document.querySelector('[rlAnnotatorContainer]').dispatchEvent(new CustomEvent('lgntoann.annotation.trash', {detail : {id : annToTrash.id, tool : annToTrash.type, commentAttached : annToTrash.commentAttached}}));
            hideTrash();
        }
    }

    function initTrash(){
        if(document.getElementById('ann-trash')) return;
        window['annotator'].ui.adder.Adder.template = `<div class="annotator-outer annotator-hide"><div id="quick-action-trash" class="quick-action">
                <div class="justify-content flex-wrap"><div class="flex-basis">
                <button id="ann-trash" class="btn btn-clear trash">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
            </div></div></div></div>`;

        s.trash = new window['annotator'].ui.adder.Adder({});
        s.trash.attach();
        // document.getElementById('ann-trash').addEventListener('click', trash, {ele : elements.container});
        document.getElementById('ann-trash').addEventListener('click', trash);
    }

    function hideTrash(){
        annToTrash = undefined;
        s.trash.hide();
    }

    function getAnnElement(ann){
        return ann._local && ann._local.highlights ? ann._local.highlights : ann.element;
    }

    function attachHoverEvent(ann, annId, elements){
        $(ann).on('mouseenter', null, annId, function (event) {
            dispatchCommentEvent('lgntoann.comment.hover', event.data, elements);
        }).on('mouseleave', null, annId , function (event) {
            dispatchCommentEvent('lgntoann.comment.hover', event.data, elements);
        }).on('click', null, annId , function (event) {
            if(elements.find('commentsBtn') && !elements.find('commentsBtn').classList.contains('btn-icon-only')) elements.find('commentsBtn').click();
            dispatchCommentEvent('lgntoann.comment.select', event.data, elements);
        });
    }

    function attachTrashEvent(element, ann){
        // if(!ann.text) {
        //     legantoUtil.attachTrashEvent(ann.element, ann.id);
        // }
        if(!ann.canDelete){
            return;
        }
        $(element).on('click', null, ann, function (event) {
            hideTrash();
            annToTrash = ann;
            s.interactionPoint = window['annotator'].util.mousePosition(event);
            s.trash.load(undefined, s.interactionPoint);
        });
    }

    function dispatchCommentEvent(event, annId, elements){
        elements.find('commentsPanel').dispatchEvent(new CustomEvent(event, {detail: annId}));
    }

    function addToArrayByType(a){
        if(!annsByEntityType[a.entityId + a.entityType]){
            annsByEntityType[a.entityId + a.entityType] = [];
        }
        annsByEntityType[a.entityId + a.entityType].push(a.id);
    }

    return {
        initQuickAction : function(htmlTemplate, toolsConfig, quickActionAdder, eventFunction){
            var quickActionHtml = ""; //app.htmlTemplate; 
            var quickActionEvents = {};
            for(t in toolsConfig){
                if(toolsConfig[t].config.quickAction){
                    quickActionHtml += toolsConfig[t].config.quickAction.html;
                }
            }
            
            window['annotator'].ui.adder.Adder.template = htmlTemplate.replace('quick-action-type', `quick-action-comment-highlight`).replace("#QUICK_ACTION_MENU#", quickActionHtml);
            quickActionAdder.adder = new window['annotator'].ui.adder.Adder({});
            quickActionAdder.adder.attach();
            menus.push(quickActionAdder);
            for(t in toolsConfig){
                if(toolsConfig[t].config.quickAction) {
                    document.getElementById(toolsConfig[t].config.quickAction.id).addEventListener('click', eventFunction, false);
                    quickActionEvents[toolsConfig[t].config.quickAction.id] = t;
                }
            }
            
            initTrash();
            return quickActionEvents;
        },
        hideTrash : hideTrash,
        handleNewAnn : function(ann, config, elements){
            ann.canDelete = true;
            this.handleLoadedAnn(ann, config, elements);
        },
        handleLoadedAnn : function(ann, config, elements){
            var ele = getAnnElement(ann);
            $(ele).attr('ann-id', ann.id);
            $(ele).attr('ann-type', ann.type);
            $(ele).attr('ann-entity-type', ann.entityType);
            ann.commentAttached = ann.commentAttached || config.attachComment;
            if(config.showTrash) attachTrashEvent(getAnnElement(ann), ann);
            if(ann.commentAttached) attachHoverEvent(getAnnElement(ann), ann.id, elements);
            addToArrayByType(ann);
        },
        attachHoverEvent : attachHoverEvent,
        addOffset : function(ann){
            if(ann.offsetTop && ann.offsetLeft) return;
            let ele = getAnnElement(ann);
            if(!ele || !ele.length){
                ann.offset = 0;
                return;
            }
            ann.offsetTop = (ann.type == 'SHAPE' ? ele[0] : ele[0].offsetParent)['offsetTop'];
            ann.offsetLeft = ann.type == 'SHAPE' ? ele[0].offsetLeft : ann.ranges[0].startOffset;
        },
        hideFloatMenus : function(){
            hideTrash();
            for(let i=0; i < menus.length; i++){
                if(menus[i].adder && menus[i].adder.isShown()) menus[i].adder.hide();
            }
        },
        getAnnForPlugin : function(ann){                 
            var json = JSON.parse(ann.attributes);
            return {
                id : ann.id,
                type : ann.type,
                ranges : json.ranges ? JSON.parse(json.ranges) : '',
                image_selection : json.image_selection ? JSON.parse(json.image_selection) : undefined,
                quote : json.quote | '',
                page : ann.page,
                visibility : ann.visibility,
                attributes : {
                color : json.color
                },
                offsetTop : json.offsetTop,
                offsetLeft : json.offsetLeft,
                commentAttached : ann.text,
                canDelete: ann.user.currentUser,
                entityType : ann.entityType,
                entityId : ann.entityId
            };
        },
        runForAllByConfig : function(annsTypeIdConfig, callback){
            annsTypeIdConfig.forEach(a => {
                let entityAnns = annsByEntityType[a.entityId + a.entityType];
                if(!entityAnns || !entityAnns.length) return;
                entityAnns.forEach(ea => callback(ea.id));
                delete annsByEntityType[a.entityId + a.entityType];
            });
        },
        disableTools : function(toolsCode, toolsConfig){
            if(toolsCode && toolsCode.length > 0) {
                toolsCode.forEach(c => {
                    if(toolsConfig[c]){
                        let ele = document.getElementById(toolsConfig[c].config.quickAction.id);
                        if(ele != null){
                            ele.classList.add('disabled');
                            ele.disable = true;
                        }
                    }
                });
            } else {
            //this will enable all tools
                Object.values(toolsConfig).forEach(c => {
                    let ele = document.getElementById(c.config.quickAction.id);
                        if(ele != null){
                            ele.classList.remove('disabled');
                            ele.disable = false;
                        }
                });
            }
        }
    }
};